import { Pipe, PipeTransform } from "@angular/core";
import parsePhoneNumber from 'libphonenumber-js'

//https://stackoverflow.com/questions/36895431/angular2-pipes-how-to-format-a-phone-number

@Pipe({ name: 'phone' })

export class PhonePipe implements PipeTransform {
	transform(val: string, args: any) {

		//https://codepen.io/rpdasilva/pen/DpbFf

		if (!val || !val.trim()) { return ''; }
		var parsedNum = parsePhoneNumber(val);

		if (parsedNum) {
			return parsedNum.formatNational();
		}

		var numb = val.match(/\d/g);
		if (!numb) {
			return '';
		}
		var value = numb.join("");

		var country, areaCode, number;

		switch (value.length) {
			case 1:
			case 2:
			case 3:
				areaCode = value;
				break;

			default:
				areaCode = value.slice(0, 3);
				number = value.slice(3);
		}

		if (number) {
			if (number.length > 3) {
				number = number.slice(0, 3) + '-' + number.slice(3, 7);
				if (number.length > 7) {
					number += " " + number.slice(8);
				}
			}
			else {
				number = number;
			}

			return ("(" + areaCode + ") " + number).trim();
		}
		else {
			return val;
		}
	}
}
